import { Observable } from 'rxjs';
import { ClientModel } from '../models/client/client.model';
import { DataClientEntity } from '../../data/repositories/client/entities/client.entity';
export abstract class  ClientRepository {
    abstract getClientAll(): Observable<ClientModel>;
    abstract getClientAllById(params: {Id:string}): Observable<ClientModel>;
    abstract getClientAllByKeyword(params: {Keyword:string}): Observable<ClientModel>;
    abstract insertClient(params:DataClientEntity):Observable<ClientModel>;
    abstract updateClient(params:DataClientEntity):Observable<ClientModel>;
    abstract statusClient(params: {Id: string}): Observable<ClientModel>;
}